import { useQuery } from '@tanstack/react-query';

import { fetchListTwoTicketStudiesApi } from '../api';

export default function useFetchListTwoData(params: any, options?: any) {
  return useQuery(
    ['tickets', 'list', 'two', 'history', params],
    fetchListTwoTicketStudiesApi,
    options
  );
}
